import Swal from 'sweetalert2';

// Menu items that stay usable while a disclosure package generates.
const ALLOWED_MENU_ITEM_SELECTOR = '.disclosures-menu-item, .submission-menu-item';

export const showDisclosureProcessingAlert = (): void => {
  Swal.fire({
    title: 'Disclosures Processing',
    text: 'The disclosure process is still running. Please wait until it completes before navigating away.',
    icon: 'warning',
    confirmButtonText: 'Ok',
  });
};

/**
 * Swallows clicks on the locked menu items while a disclosure package generates and explains why, so the
 * items are not silently inert. Listens in the capture phase to run before routerLink navigation, and
 * returns a teardown function for ngOnDestroy.
 */
export const blockMenuClicksWhileDisclosuresProcess = (
  root: HTMLElement,
  isProcessing: () => boolean
): (() => void) => {
  const handler = (event: Event): void => {
    if (!isProcessing()) {
      return;
    }

    const target = event.target as HTMLElement | null;
    if (target?.closest(ALLOWED_MENU_ITEM_SELECTOR)) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    showDisclosureProcessingAlert();
  };

  root.addEventListener('click', handler, true);

  return () => root.removeEventListener('click', handler, true);
};
